import React from 'react';
import InvoiceManual from 'components/Tvendo/Shopping/Operations/Invoices/InvoiceManual';

export default function () {
  return <InvoiceManual />;
}
